import {
  Directive,
  HostListener,
  Input,
  OnInit,
  ElementRef
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR, ControlValueAccessor
} from '@angular/forms';

@Directive({
  selector: '[myMaskCurrency]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: MaskCurrencyDirective,
    multi: true
  }]
})
export class MaskCurrencyDirective implements ControlValueAccessor, OnInit {

  onTouched: any;
  onChange: any;

  separadorDecimal: string;
  separadorMilhar: string;
  prefixo: string;

  @Input('myMaskCurrency') myMaskCurrency: any;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.separadorDecimal = this.myMaskCurrency.decimal || ',';
    this.separadorMilhar = this.myMaskCurrency.milhar || '.';
    this.prefixo = this.myMaskCurrency.prefixo || '';
  }

  writeValue(value: any): void {
    if (value) {
      if (!isNaN(value)) {
        value = value.toFixed(2);
      }
      this.el.nativeElement.value = this.aplicarMascara(String(value));
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {

    let valor: string = this.aplicarMascara($event.target.value);

    if (valor === '') {
      this.onChange='';
      $event.target.value = '';
      return;
    }

    if (this.separadorDecimal === ',') {
     this.onChange=valor.replace(/\./g, '').replace(',', '.');
    } else {
      this.onChange=valor.replace(/\,/g, '');
    }

    $event.target.value = valor;
  }

  @HostListener('blur', ['$event'])
  onBlur($event: any) {
    var pattern = '0' + this.separadorDecimal + '00';
    if ($event.target.value.indexOf(pattern) === -1) {
      return;
    }
    this.onChange='';
    $event.target.value = '';
  }

  /**
   * Aplica a máscara a determinado valor.
   *
   * @param string valorConverter
   * @return string
   */
  aplicarMascara(valorConverter: string): string {
    let valorNum = parseInt(valorConverter.replace(/\D/g, ''), 10);
    let valormyMask = '';
    let valor: string;

    if (isNaN(valorNum)) {
      return '';
    }

    valor = valorNum.toString();
    switch (valor.length) {
      case 1:
        valormyMask = '0' + this.separadorDecimal +
          '0' + valor;
        break;
      case 2:
        valormyMask = '0' + this.separadorDecimal + valor;
        break;
      case 3:
        valormyMask = valor.substr(0, 1) + this.separadorDecimal +
          valor.substr(1, 2);
        break;
      default:
        break;
    }

    if (valormyMask === '') {
      let sepMilhar = 0;
      for (let i = (valor.length - 3); i >= 0; i--) {
        if (sepMilhar === 3) {
          valormyMask = this.separadorMilhar + valormyMask;
          sepMilhar = 0;
        }
        valormyMask = valor.charAt(i) + valormyMask;
        sepMilhar++;
      }
      valormyMask = valormyMask + this.separadorDecimal +
        valor.substr(valor.length - 2, 2);
    }

    if (this.prefixo !== '') {
      valormyMask = this.prefixo + ' ' + valormyMask;
    }

    return valormyMask;
  }

}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/directives/mask-currency/mask-currency.ts